import React from 'react';
import PropTypes from 'prop-types';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.css';
import FormDialog from '../../scenes/Dialog/components/FormDialog';
import AvatarEditorForm from '../../scenes/Form/components/AvatarEditorForm';
import Avatar from '../Avatar';

const AvatarWithUpload = ({
  name,
  image,
  size = 200,
  editable = true,
  labelStyles,
  onChange,
  onBlur,
}) => {
  const uploadHandler = () => {
    FormDialog({
      compact: true,
      modeless: false,
      popupTitleStyles: {
        padding: window.innerWidth < 480 ? '0 20px' : '0 25px',
      },
      popupInnerStyles: {
        padding: window.innerWidth < 480 ? '0' : '0 20px',
        marginTop: '45px',
      },
      popupStyles: {
        minHeight: '30vh',
        maxWidth: '452px',
      },
      popupContentStyles: {
        paddingTop: 0,
      },
      form: (actions, params) => (
        <AvatarEditorForm actions={actions} params={params} />
      ),
    }).then(picture => {
      onChange(name, picture);
      onBlur(name, true, true);
    });
  };

  return (
    <div className="avatar-with-upload">
      <div className="avatar-with-upload__inner">
        {image && (
          <div style={{ position: 'absolute', right: 0 }}>
            <FontAwesomeIcon
              onClick={() => onChange(name, null)}
              icon={faTimes}
              color="#f40"
              size="lg"
              className="basic-input-file__button"
            />
          </div>
        )}
        <Avatar size={size} name={name} image={image} />
        {editable && (
          <label
            className="avatar-with-upload__label"
            style={labelStyles}
            onClick={uploadHandler}
          />
        )}
      </div>
    </div>
  );
};

AvatarWithUpload.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  editable: PropTypes.bool,
  size: PropTypes.number,
  labelStyles: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default AvatarWithUpload;
